<dialog
    class="ap {{ 'ap-' + darkmodeSetting$ }} ap-modal__dialog {{ modalOptions.classIdentifier }} {{
        'ap-modal__dialog--' + size.toLowerCase()
    }}"
    [ngClass]="{
        'ap-modal__dialog--fullscreen': modalOptions.fullscreen,
        'ap-modal__dialog--with-header': modalOptions.showHeader
    }"
    tabindex="-1"
    (keydown.escape)="cancel()"
    (mouseup)="onMouseUp($event)"
    (mousedown)="onMouseDown($event)"
    data-testid="dialog"
    [attr.aria-describedby]="modalOptions.ariaDescribedby && modalOptions.ariaDescribedby !== '' ? modalOptions.ariaDescribedby : null"
    [attr.aria-labelledby]="modalOptions.showHeader ? 'ap-modal__title-' + currentModalNumber : null"
    [attr.aria-label]="modalOptions.showHeader ? null : modalOptions.ariaLabel"
>
    <div class="ap-modal__wrapper" data-testid="wrapper">
        @if (!this.externalHeader) {
            @if (modalOptions.showHeader) {
                <div class="ap-modal__header" data-testid="header">
                    <h1 [id]="'ap-modal__title-' + currentModalNumber" class="ap-modal__title" data-testid="title">
                        {{ modalOptions.title }}
                    </h1>
                </div>
            }
            @if (modalOptions.isSubModal) {
                <button
                    type="button"
                    class="ap-modal__back-button"
                    data-testid="modal-back"
                    [ngClass]="{
                        'ap-modal__back-button--on-header': modalOptions.showHeader
                    }"
                    (click)="back()"
                    [attr.aria-label]="'modal.back' | apContent"
                >
                    <ap-icon [name]="'chevron-left'" [size]="'medium'"></ap-icon>
                </button>
            }
            @if (modalOptions.cancelable) {
                <button
                    type="button"
                    class="ap-modal__close-button"
                    [ngClass]="{
                        'ap-modal__close-button--on-header': modalOptions.showHeader,
                        'ap-modal__close-button--on-submodal': modalOptions.isSubModal
                    }"
                    (click)="cancel()"
                    data-testid="modal-close"
                    [attr.aria-label]="'modal.close' | apContent"
                >
                    <ap-icon [name]="'close'" [size]="'medium'"></ap-icon>
                    <ap-icon [name]="'chevron-left'" [size]="'medium'"></ap-icon>
                </button>
            }
        }
        <div
            class="ap-modal__content"
            data-testid="content"
            [class.no-bottom-padding]="modalOptions.footerTemplate"
            [attr.tabindex]="modalOptions.showHeader ? '-1' : null"
        >
            <ng-container #componentContainer></ng-container>
        </div>

        <div class="ap-modal__footer" data-testid="footer">
            <ng-container #componentFooter></ng-container>
        </div>
    </div>
</dialog>
